<template>
  <div :class="['base-page', { 'lock-scroll': lockViewportScroll }]">
    <div :style="pageContentStyle" class="page-content">
      <slot />
    </div>
    <!-- <div v-if="showBackBtn" class="back-btn" @click.stop="goBack">
      <img class="arrow" :src="arrowImg" alt="" />
      返回
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'BasePage',
  props: {
    background: {
      type: String,
      default: '#f7f8fa'
    },
    showBackBtn: {
      type: Boolean,
      default: false
    },
    backToIEP: {
      type: Boolean,
      default: false
    },
    backReplaceRouterPath: {
      type: String,
      default: ''
    },
    lockViewportScroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    arrowImg () {
      return require('../assets/images/common/back-arrow.png')
    },
    pageContentStyle () {
      const heightPx = `${this.viewportHeight}px`
      const baseStyle = {
        width: '100%',
        background: this.background
      }
      if (this.lockViewportScroll) {
        return {
          ...baseStyle,
          height: heightPx,
          minHeight: heightPx,
          overflowY: 'auto',
          webkitOverflowScrolling: 'touch'
        }
      }
      return {
        ...baseStyle,
        minHeight: heightPx
      }
    }
  },
  data () {
    return {
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0
    }
  },
  mounted () {
    this.updateViewportHeight()
    window.addEventListener('resize', this.updateViewportHeight)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateViewportHeight)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateViewportHeight)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateViewportHeight)
    }
  },
  methods: {
    updateViewportHeight () {
      if (typeof window === 'undefined') return
      this.viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight
    },
    goBack () {
      if (this.backReplaceRouterPath) {
        this.$router.replace(this.backReplaceRouterPath)
      } else if (this.backToIEP) {
        // eslint-disable-next-line
        window.location.href = `${process.env.iepUrl}/mobile`
      } else {
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.replace('/home')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.base-page {
  display: flex;
  width: 100%;

  &.lock-scroll {
    overflow: hidden;
  }
}

.page-content {
  flex: 1;
}

.back-btn {
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 99;
  top: 75%;
  right: 0;
  transform: translateY(-50%);
  width: 53px;
  height: 37px;
  padding-left: 10px;
  background: #EB1700;
  border-radius: 19px 0 0 19px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  .arrow {
    margin-right: 6px;
    width: 8px;
    height: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BasePage.vue